import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const antIcon = <LoadingOutlined style={{
  fontSize: 24,
  color: 'white',
  textAlign: 'center'
}} spin />;
const LoadingSpinner = () => <Spin className="spin_loading" indicator={antIcon} />;
export default LoadingSpinner;